module.exports = __webpack_public_path__ + "static/media/sh_logo_full_horizontal.c81a4909.png";